import { Observer } from '@poa/state';
import React from 'react';
import { getValue } from '../../data-table/data-table-helpers';

export function ProfileTabIncome({ state }) {
  return (
    <div className="tab active" data-tab="questionnaire">
      <div className="tab__inner">
        <div className="account-income">
          <div className="account-income__head">
            <div className="account-income__total">ИТОГ: {state.model.salary.summary}</div>
            <div className="account-income__level">
              УРОВЕНЬ АНКЕТЫ: {state.model.salary.accountLevel}
            </div>
            <div className="account-income__filter">
              <Observer>
                {() => (
                  <select
                    name="r"
                    value={state.salarySite}
                    onChange={({ currentTarget }) => {
                      state.salarySite = currentTarget.value;
                    }}
                  >
                    {state.model.salary.sites.map((site, idx) => (
                      <option key={idx} value={site.id}>
                        {site.title}
                      </option>
                    ))}
                  </select>
                )}
              </Observer>
              <i className="arrow-bottom" style={{ height: '8px', width: '10px' }}>
                <svg id="icon-arrow-bottom" viewBox="0 0 9.5 4.93" width="100%" height="100%">
                  <path d="M4.75 4.93L0 .75.66 0l4.09 3.6L8.84 0l.66.75-4.75 4.18z" />
                </svg>
              </i>
            </div>
          </div>
          <div className="account-income__body">
            <table className="account-income__table">
              <thead>
                <tr>
                  <th />
                  {state.model.salary.data.thead.map((head, idx) => (
                    <th key={idx}>
                      <b>{head}</b>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {state.salaryDataFiltered.map(tbody => (
                  <tr key={tbody.id}>
                    <td>
                      <b>{tbody.title}</b>
                    </td>
                    {tbody.data.map(item => (
                      <td key={item.id}>{getValue(parseFloat(item.value))}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td>ИТОГО</td>
                  {state.model.salary.data.tfoot.map((tfoot, idx) => (
                    <th key={idx}>{getValue(parseFloat(tfoot))}</th>
                  ))}
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
